export default __webpack_public_path__ + "83b1fe90fa1ce7a77c73cc905faa7745.svg";